import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RespuestaTokenDto } from 'src/app/dto/respuesta-token-dto';
import { UidDto } from 'src/app/dto/uid-dto';
import { LoginService } from 'src/app/services/login.service';
import { PersonaService } from 'src/app/services/persona.service';
import { VerificacionService } from 'src/app/services/verificacion.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-validar',
  templateUrl: './validar.component.html',
  styleUrls: ['./validar.component.css']
})
export class ValidarComponent implements OnInit {

  RespuestaToken: RespuestaTokenDto = null;
  form: FormGroup;
  grupo: UidDto[];
  estudiante: boolean;
  otp: string[] = ['', '', '', '', ''];

  constructor(
    private router: Router,
    private verificacionService: VerificacionService,
    private fb: FormBuilder,
    private validador: VerificacionService,
    private personaService: PersonaService,
    private loginService: LoginService,
  ) { }

  ngOnInit() {
    this.build();
    this.obtenerGrupos();
  }

  obtenerGrupos() {
    this.personaService.ObtenerUid().subscribe(res => {
      this.grupo = res;

      this.grupo.map((item: any) => {
        if (item.nombre.trim() == 'ESTUDIANTE') {
          this.estudiante = true;
        } else {
          this.estudiante = false;
        }
      })

      if (this.estudiante) {
        this.validarEstudiante();
      } else {
        this.validarOtros(); //SE DEBE COMENTAR PARAR NO VALIDAR
      }
    });
  }

  // valida si el estudiante puede entrar al modulo de evaluacion
  validarEstudiante() {
    this.personaService.validarEstudiante().subscribe(data => {

      if (!data) {
        Swal.fire({
          icon: 'error',
          title: '¡No puede acceder a este módulo!',
          confirmButtonColor: '#8F141B',
          confirmButtonText: "Aceptar"
        })
        sessionStorage.clear();
        this.router.navigate(['/login']);
      } else {
        this.obtener();
      }
    })
  }

  validarOtros() {
    this.personaService.validarOtros().subscribe(data => {

      if (!data) {
        Swal.fire({
          icon: 'error',
          title: '¡No puede acceder a este módulo!',
          confirmButtonColor: '#8F141B',
          confirmButtonText: "Aceptar"
        })
        sessionStorage.clear();
        this.router.navigate(['/login']);
      } else {
        // Solo enviar el código por correo si el usuario tiene acceso
        this.obtener();
      }
    })
  }

  private build() {
    this.form = this.fb.group({
      token: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]]
    });
  }

  // MÉTODO PARA OBTENER CODIGO DE VERIFICACIÓN 
  obtener() {
    this.verificacionService.obtener().subscribe(res => {
      this.RespuestaToken = res;

    }, (err: HttpErrorResponse) => {
      if (err.status == 401) {

        Swal.fire({
          icon: 'error',
          title: '¡Error al obtener código de verificación!',
          confirmButtonColor: '#8F141B',
          confirmButtonText: "Aceptar"
        })
        sessionStorage.clear();
        this.router.navigate(['/login']);
      }
    });
  }

  // MÉTODO PARA VALIDAR CÓDIGO DE VERIFICACIÓN
  validar() {
    let codigo: string = this.form.get('token').value;
    this.verificacionService.verificar(codigo).subscribe(res => {
      this.RespuestaToken = res;

      localStorage.setItem("tok", btoa("1." + Math.random() * 9999999));
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: '¡Código de verificación válido!',
        showConfirmButton: false,
        timer: 1500
      })
      this.router.navigate(['/perfil']);
    }, (err: HttpErrorResponse) => {
      if (err.status == 401) {

        Swal.fire({
          icon: 'error',
          title: '¡Código de verificación inválido!',
          confirmButtonColor: '#8F141B',
          confirmButtonText: "Aceptar"
        })
      }
    });
  }

  // OTP LOGIC
  onOtpChange(value: string, index: number) {
    this.otp[index] = value.toUpperCase();
    this.updateTokenValue();

    if (value && index < 4) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  onKeyDown(event: any, index: number) {
    if (event.key === 'Backspace' && !this.otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) {
        prevInput.focus();
      }
    }
  }

  onPaste(event: ClipboardEvent) {
    const pasteData = event.clipboardData.getData('text').toUpperCase();
    if (pasteData.length === 5) {
      for (let i = 0; i < 5; i++) {
        this.otp[i] = pasteData[i];
      }
      this.updateTokenValue();
    }
    event.preventDefault();
  }

  trackByIndex(index: number, item: any) {
    return index;
  }

  private updateTokenValue() {
    const tokenValue = this.otp.join('');
    this.form.get('token').setValue(tokenValue);
    this.form.get('token').markAsTouched();
  }

}
